import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["beforeIcon", "afterIcon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useThemeUI } from 'theme-ui';
import { Fragment } from 'react';
import loadable from '@loadable/component';
import { DynamicSparkIcon } from '../spark-icons/dynamic-spark-icon';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var ButtonLink = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "button-link-button-link";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },
  importAsync: function importAsync() {
    return import(
    /* webpackChunkName: "button-link-button-link" */
    '../button-link/button-link');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;

    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../button-link/button-link");
    }

    return eval('require.resolve')("../button-link/button-link");
  }
});
var Button = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "button-default";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },
  importAsync: function importAsync() {
    return import(
    /* webpackChunkName: "button-default" */
    './button-default');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;

    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./button-default");
    }

    return eval('require.resolve')("./button-default");
  }
});
var ModalButton = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "compounds-modal-button";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },
  importAsync: function importAsync() {
    return import(
    /* webpackChunkName: "compounds-modal-button" */
    '../../compounds/modal-button');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;

    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../../compounds/modal-button");
    }

    return eval('require.resolve')("../../compounds/modal-button");
  }
});

var EvButton = function EvButton(_ref) {
  var _theme$elements$butto, _theme$elements$butto2, _theme$elements$butto3, _theme$elements$butto4;

  var beforeIcon = _ref.beforeIcon,
      afterIcon = _ref.afterIcon,
      props = _objectWithoutProperties(_ref, _excluded);

  var href = props.href,
      link = props.link,
      modalContent = props.modalContent,
      variant = props.variant,
      text = props.text;

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var hrefLink = href || link;

  var getButtonVariant = function getButtonVariant(element) {
    return "elements.buttons.".concat(variant ? "variants.".concat(variant, ".").concat(element) : element);
  };

  var iconSize = ((_theme$elements$butto = theme.elements.buttons) === null || _theme$elements$butto === void 0 ? void 0 : (_theme$elements$butto2 = _theme$elements$butto.icon) === null || _theme$elements$butto2 === void 0 ? void 0 : _theme$elements$butto2.size) || 22;
  var iconColor = ((_theme$elements$butto3 = theme.elements.buttons) === null || _theme$elements$butto3 === void 0 ? void 0 : (_theme$elements$butto4 = _theme$elements$butto3.icon) === null || _theme$elements$butto4 === void 0 ? void 0 : _theme$elements$butto4.color) || 'white';

  var ButtonChildren = _jsxs(Fragment, {
    children: [beforeIcon ? _jsx("span", {
      sx: {
        variant: getButtonVariant('beforeIcon')
      },
      children: _jsx(DynamicSparkIcon, {
        size: iconSize,
        color: iconColor,
        glyph: beforeIcon,
        direction: "left"
      })
    }) : null, text, afterIcon ? _jsx("span", {
      sx: {
        variant: getButtonVariant('afterIcon')
      },
      children: _jsx(DynamicSparkIcon, {
        size: iconSize,
        color: iconColor,
        glyph: afterIcon,
        direction: "right"
      })
    }) : null]
  });

  return modalContent ? _jsx(ModalButton, _objectSpread({}, props)) : hrefLink ? _jsx(ButtonLink, _objectSpread(_objectSpread({}, props), {}, {
    children: ButtonChildren
  })) : _jsx(Button, _objectSpread(_objectSpread({}, props), {}, {
    children: ButtonChildren
  }));
};

export default EvButton;
//# sourceMappingURL=index.js.map